<template>
  <div class="payment-success-container">
    <div class="success-box">
      <img
        src="../assets/success_payment.png"
        alt="Оплата успешна"
        class="success-icon"
      />

      <h2 class="success-title">Оплата прошла успешно 🎉</h2>

      <p class="success-text">
        Ваша подписка активируется.<br />
        Через <b>{{ countdown }}</b> сек. вы будете перенаправлены в премиум-раздел.
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const countdown = ref(5);
let timer = null;

onMounted(() => {
  timer = setInterval(() => {
    countdown.value--;

    if (countdown.value <= 0) {
      clearInterval(timer);
      router.push("/profile?section=premium");
    }
  }, 1000);
});

onUnmounted(() => {
  if (timer) clearInterval(timer);
});
</script>

<style scoped>
.payment-success-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #161616;
}

.success-box {
  background-color: #1f1f1f;
  padding: 32px;
  border-radius: 12px;
  text-align: center;
  width: 360px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}

.success-icon {
  width: 90px;
  margin-bottom: 16px;
}

.success-title {
  font-size: 22px;
  font-family: "Eastman-Bold", sans-serif;
  color: #ffffff;
  margin-bottom: 12px;
}

.success-text {
  font-size: 14px;
  font-family: "Eastman-Regular", sans-serif;
  color: #cccccc;
  line-height: 1.5;
}
</style>